import {
  TOPOLOGY_ADD_SERVERS,
  TOPOLOGY_CHECK_SERVERNAME,
} from "@shared/services/tour/urls/dashboard-urls.ts";

import addServersToTopology from "@shared/services/tour/mockedApis/topology/addServersToTopology.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";

export default {
  [TOPOLOGY_CHECK_SERVERNAME]: () => genericEmptyResponse(),
  [TOPOLOGY_ADD_SERVERS]: () => addServersToTopology(),
} satisfies TourUrlMapping;
